import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';

export const useSubscriptionPlanCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      const res = await request.post('/subscription-plan', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription-plan-list'] });
    }
  });
};

export const useSubscriptionPlanUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string, data: any }) => {
      const res = await request.patch(`/subscription-plan/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription-plan-list'] });
    }
  });
};

export const useSubscriptionPlanDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/subscription-plan/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription-plan-list'] });
    }
  });
};
